import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const UnauthorizeScreen = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 8 }}>
      <Box>
        <img
          src="https://cdn-icons-png.flaticon.com/512/564/564619.png" // Replace with your own image URL or local import
          alt="Not Authorized"
          style={{ width: "150px", marginBottom: "24px" }}
        />
        <Typography variant="h4" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          You are not authorized to access this page.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
      </Box>
    </Container>
  );
};

export default UnauthorizeScreen;
